import { ValidacaoExecucaoCicloView } from './ValidacaoExecucaoCiclo.View'
import { validacaoExecucaoCicloIO } from './ValidacaoExecucaoCiclo.IO'
import { composeIO } from 'react-compose-io'

export const ValidacaoExecucaoCiclo = composeIO(ValidacaoExecucaoCicloView, validacaoExecucaoCicloIO)
